import * as React from 'react';
import { SurfaceContextWithProperties } from '../../../../types/contexts';
import { createSurfaceContextWithPropertiesProvider } from '../../../common/surface-context-provider';
import { ReplaceSnapshotDialogProps } from './replace-snapshot-dialog';

export type ReplaceSnapshotDialogProperties = Omit<ReplaceSnapshotDialogProps, 'isOpen' | 'onDismiss'>;

export const ReplaceSnapshotDialogContext = React.createContext<
    SurfaceContextWithProperties<ReplaceSnapshotDialogProperties>
>({
    isOpen: false,
});

export const ReplaceSnapshotDialogContextProvider =
    createSurfaceContextWithPropertiesProvider<ReplaceSnapshotDialogProperties>(ReplaceSnapshotDialogContext);
